import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { Container, P, useDripsyTheme, View } from "dripsy";
import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ActivityIndicator, Linking } from "react-native";

import Button from "./button";
import Error from "@features/error/error";
import { useSafeArea } from "@provider/safe-area/use-safe-area";
import Spacer from "@components/Spacer";

function ErrorFallback({ error, resetErrorBoundary }: { error: any; resetErrorBoundary: any }) {
  const insets = useSafeArea();
  return (
    <View
      sx={{
        marginTop: insets.top,
        marginBottom: insets.bottom,
        marginLeft: insets.left,
        marginRight: insets.right,
      }}
    >
      <Container sx={{ padding: 12 }}>
        <P>
          Er is iets foutgegaan. Probeer de app opnieuw op te starten. Als dit vaak gebeurd, meld dit bij ons en vermeld
          de foutmelding.
        </P>
        <Error error={error?.message} isError />
        <Spacer />
        <Button
          onPress={() => {
            resetErrorBoundary?.();
          }}
        >
          Probeer opnieuw
        </Button>
        <Spacer />
        <Button
          onPress={() => {
            Linking.openURL("mailto:klantenservice@degroteverleiding.nl");
          }}
          outline
          description="Beschrijf wat er fout ging en welke foutmelding je kreeg"
        >
          Mail met klantenservice
        </Button>
      </Container>
    </View>
  );
}

export function LoadingCallback() {
  const {
    theme: { colors },
  } = useDripsyTheme();
  return (
    <View style={{ marginTop: 100, height: 100 }}>
      <ActivityIndicator color={colors.$primary} />
    </View>
  );
}

export default function AsyncBoundary({ children }: { children: any }) {
  const [error, setError] = React.useState(false);

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // reset the state of your app so the error doesn't happen again
            reset();
            setError(false);
          }}
          onError={() => {
            setError(true);
          }}
        >
          <React.Suspense fallback={<LoadingCallback />}>{error ? null : children}</React.Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
